export default "__VITE_ASSET__43e4c816__"